// test2006
(2006 && 0);
